import { removeInvalidOptions } from '../../field-viewer/shared-normalizers';
export const servicesMultiChoiceViewer = {
    normalizeLoadedValue: removeInvalidOptions
};

//# sourceMappingURL=definition-viewer.js.map